import styled from 'styled-components';
export const Wrapper = styled.div `
  width: 33.2rem;
  height: 18.2rem;
  transform: translateX(4rem);

  img {
    width: 100%;
    height: auto;
  }

  @media screen and (max-width: 500px) {
    width: 23rem;
    height: 14.9rem;
    transform: translateX(0);
  }
`;
export default { Wrapper };
